<template>
  <div id="doctor-home" class="row">
    <div v-if="loader" class="loader"></div>
    <div class="col-lg-3"></div>
    <div class="col-lg-9 doctor-home-container">
      <div class="row">
        <div class="col-lg-12 text-center doctor-image">
          <span v-if="doctor.thumb">
            <img class="uploading-image img-circle img-responsive" v-bind:src="doctor.thumb" :alt="translation.profile.altImage + doctor.name">
          </span>
          <span v-else>
            <img  class="uploading-image img-circle img-responsive" src="../assets/img/doctor-home-icon-default.svg" alt="Default Image">
          </span>
        </div>
        <div class="col-lg-12 text-center">
          <h3 class="text-center">{{translation.header.welcome + translation.petReview.addByDoctor + doctor.doctorLastName}}</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-4 col-md-6">
              <router-link to="/add-patient">
                <div class="image-container">
                  <img src="../assets/img/backgrounds/vets.svg" alt="Notification Image">
                </div>
                <div class="home-notification">
                  <h4 class="text-center">
                    {{translation.doctor.addPatient}}
                  </h4>
                  <div class="user-home-text home-vets">

                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-lg-4 col-md-6">
              <router-link to="/search-pet">
                <div class="image-container">
                  <img src="../assets/img/backgrounds/searching-pet.svg" alt="Add Image">
                </div>
                <div class="home-notification text-center">
                  <h4>
                    {{translation.button.search}}
                  </h4>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="row">
        <DoctorStatistic/>
        <div class="col-sm-12 text-center">
          <h3>{{translation.doctor.paymentDoctor}}</h3>
        </div>
      </div> -->

      <Footer />
    </div>
  </div>
</template>

<script>

import DoctorStatistic from './statistic/DoctorStatistic.vue';
export default {
  name: 'DoctorHome',
  components: {
    DoctorStatistic
  },
  data(){
    return {
      translation: null,
      loader: false,
      doctor: [],

    }
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
    window.pageHeader = this.translation.header.home;
    this.getDoctor();
 },
 methods: {
   getDoctor: function(){
     this.loader = true;
     var self = this;
     axios.get('get-doctor')
     .then(function (response){
         self.loader = false;
         self.doctor = response.data.result;
         if (!response.data.result.doctorLoggedIn) {
           localStorage.removeItem('doctorLoggedIn');
           self.$router.push({ name: 'home', params: { lang: window.lang } })
         }

     })
     .catch(err => console.error(err))
   },

   toFormData: function (obj){
     var form_data = new FormData();
     for (var key in obj) {
       form_data.append(key,obj[key]);
     }
     return form_data;
   },
   togglePetFn: function(){
     this.togglePet = !this.togglePet;
   }
 }
}
</script>

<style>
#doctor-home .menu{
  margin-top: 5em;
}
#doctor-home .doctor-home-container{

  background-image: url('../assets/img/backgrounds/background-after-login.jpg');
  background-repeat:no-repeat;
  max-width:inherit;
  min-height: 100vh;
  padding-top: 9em;
  background-position: center;
  background-size: cover;
  padding-bottom: 11em;
}
#doctor-home .doctor-home-container img{
  display: inline-block;
}
#doctor-home .doctor-image img {
  width: 10em;
  height: 10em;
}
#doctor-home h3,h4{
  color: #3057B0;
}
#doctor-home .image-container {
  position: relative;
}
#doctor-home .image-container img{
  width: 100%;
}

#doctor-home .notification-lengt {
  display: inline-block;
  background-color: #FE7154;
  width: 2em;
  height: 2em;
  font-size: 1.5em;
  border-radius: 5em;
  color: #fff;
}
#doctor-home .col-md-6 .home-notification, #doctor-home .col-lg-6 .home-notification{
  position: absolute;
  top: 3em;
  left: 0;
  right: 0;
  border-radius: .75em;
}
#doctor-home .doctor-home-mobile-container{
  display: none;
}
#doctor-home .doctor-home-mobile-container .doctor-image-home img{
  display: inline-block;
}
#doctor-home .footer {
  color: #707070;
}
#doctor-home .footer .footer-menu {
  text-align: center;
}
#doctor-home .footer a{
  color: #707070;
}
#doctor-home .footer a:hover{
  color: #3057B0;
}
#doctor-home .doctor-home-text{
  width: 80%;
  margin: 0 auto;
  color: #fff;
  margin-top: 13em;
}
</style>
